<template>
  <div class="main-card mb-3 card">
    <div class="card-header">
      Dropbox OAuth2
      <div class="btn-actions-pane-right">
        <button type="submit" class="btn btn-primary" @click.stop.prevent="handleClickSave">Save</button>
      </div>
    </div>
    <div class="card-body">
      <div class="position-relative form-group w-100 d-flex flex-wrap">
        <div class="flex-1 pr-2">
          <input class="form-control has-tip" data-title="Api Key" placeholder="Api Key" :value="values.key" @change.stop.prevent="store.commit('values.dropbox.key', $event.currentTarget.value)" type="text" />
        </div>
        <div class="flex-1 pr-2">
          <input class="form-control has-tip" data-title="Api Secret" placeholder="Api Secret" :value="values.secret" @change.stop.prevent="store.commit('values.dropbox.secret', $event.currentTarget.value)" type="text" />
        </div>
        <button type="submit" class="btn btn-success mr-2" @click.stop.prevent="handleRequestAccessToken">Request Access Token</button>
        <button type="submit" class="btn btn-primary" @click.stop.prevent="handleUpdateTokenToServerFile">Update Token To Server File</button>
      </div>
      <div class="position-relative form-group w-100 d-flex flex-wrap">
        <textarea class="form-control has-tip" data-title="Description" placeholder="Description" v-html="values.description" @change.stop.prevent="store.commit('values.dropbox.description', $event.currentTarget.value)"></textarea>
      </div>
      <div class="position-relative form-group w-100 d-flex flex-wrap">
        <small class="w-100">
          <span>Add the following Redirect URI to the dropbox app:</span>
          <br />
          <div v-for="(callback_url, index) in data.callback_urls" :key="index" class="text-primary select-all">
            {{ callback_url || '' }}
          </div>
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  computed: {
    storeId() {
      return 'main'
    },
    data() {
      return this.store.getter('data.dropbox', {})
    },
    values() {
      return this.store.getter('values.dropbox', {})
    },
    message() {
      return this.data.message || {}
    }
  },
  methods: {
    handleRequestAccessToken() {
      this.$util.post(`option/more/dropbox/request-access-token`, this.values).then((response) => {
        if (response.status == 'success') {
          window.location.href = response.auth_url
        }
      })
    },
    handleUpdateTokenToServerFile() {
      this.$util.post(`option/more/dropbox/update-token-to-server-file`, this.values).then((response) => {
        if (response.status == 'success') {
          window.open(response.url, '_blank').focus()
        }
      })
    },
    handleClickSave() {
      this.$emit('submitSetting')
    }
  },
  watch: {
    message(value) {
      try {
        if (Object.keys(value).length > 0) {
          this.$util.notify(value || {})
        }
      } catch {
        return null
      }
    }
  }
}
</script>
